import { render } from "./AwaitingPayment.vue?vue&type=template&id=ff78ec96"
import script from "./AwaitingPayment.vue?vue&type=script&lang=js"
export * from "./AwaitingPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__